import Region from "../../../../../models/Region";

class CoverageLine {
  constructor(points, analysis, chr, sampleInd) {
    this.points = points;
    this.analysis = analysis;
    this.length = points.length;
    this.sampleInd = sampleInd;
    const start = points[0]?.region?.x0 || 0;
    const end = points[points.length - 1]?.region?.x1 || 0;
    this.region = new Region(start, end, chr);
  }
}

export default CoverageLine;
